// extracted by mini-css-extract-plugin
export default {"createListForm":"createListForm---GCDQA","createListFooterWrap":"createListFooterWrap---WuYqK"};